/* eslint-disable import/namespace */

import { StrictMode, startTransition } from "react";
import { HydratedRouter } from "react-router/dom";

import { startDevoPlaybackRuntime } from "./components/audio-player/runtime/devoPlaybackRuntime";
import { createDocumentRoot } from "./lib/react-document-root";
import { createQueryClient } from "./lib/react-query";
import { initializeSentry } from "./lib/sentry.client";
import { initializeAlgoliaInsightsClient } from "./services/algolia-insights.client";

const clientEntrySingleton = (() => {
  const globalScope = globalThis as typeof globalThis & {
    __worshipDevoClientEntry?: {
      root: ReturnType<typeof createDocumentRoot> | null;
    };
  };

  if (!globalScope.__worshipDevoClientEntry) {
    globalScope.__worshipDevoClientEntry = {
      root: null,
    };
  }

  return globalScope.__worshipDevoClientEntry;
})();

export const queryClient = createQueryClient();
queueMicrotask(() => {
  startDevoPlaybackRuntime();
  initializeAlgoliaInsightsClient();
});

initializeSentry();

startTransition(() => {
  const app = (
    <StrictMode>
      <HydratedRouter />
    </StrictMode>
  );

  if (clientEntrySingleton.root) {
    clientEntrySingleton.root.render(app);
    return;
  }

  clientEntrySingleton.root = createDocumentRoot(document);
  clientEntrySingleton.root.render(app);
});
